// src/api/logs.js
import api from "../auth/api";

// Base resuelto por tu axios (src/auth/api.js)
export const API_BASE = (
  api && api.defaults && api.defaults.baseURL ? api.defaults.baseURL : ""
).replace(/\/+$/, "");

// Helpers de token
function getToken() {
  return localStorage.getItem("token") || "";
}

/** Info del archivo de logs */
export async function getLogInfo() {
  const { data } = await api.get("/logs/info");
  return data; // { ok, exists, path, size?, mtime? }
}

/** Últimas N líneas del log */
export async function getLatestLines(n = 500) {
  const { data } = await api.get("/logs/latest", { params: { n } });
  return data && Array.isArray(data.lines) ? data.lines : [];
}

/**
 * URL absoluta para el streaming SSE (server-sent events).
 * Incluye token por query (?t=) y además podrás enviar Authorization header desde el hook.
 */
export function makeStreamUrl() {
  const t = getToken();
  const q = t ? `?t=${encodeURIComponent(t)}` : "";
  return `${API_BASE}/logs/stream${q}`;
}

/** Href para descargar el log, compatible con <a> (usa ?t=token) */
export function makeDownloadHref() {
  const t = getToken();
  const q = t ? `?t=${encodeURIComponent(t)}` : "";
  return `${API_BASE}/logs/download${q}`;
}
